module.exports = __webpack_public_path__ + "static/media/home_banner_2.3067b80d.jpg";